import { type } from '../constants/manageNumbersConstant'
import { RenewNumberReducer } from '../models/manageNumbers.interface'

const initialSubState: RenewNumberReducer = {
    renewNumberInit: false,
    renewNumberSuccess: false,
    renewNumberError: false,
    renewNumberErrorMsg: 'string',
}

const renewNumberReducer = (state: RenewNumberReducer = initialSubState, action: any): RenewNumberReducer => {

    switch (action.type) {
        case type.RENEW_NUMBER_INIT:
            return {
                ...state,
                renewNumberInit: true,
                renewNumberError: false
            }
        case type.RENEW_NUMBER_SUCCESS:
            return {
                ...state,
                renewNumberInit: false,
                renewNumberError: false,
            }
        case type.RENEW_NUMBER_FAILED:
            return {
                ...state,
                renewNumberInit: false,
                renewNumberError: true,
                renewNumberErrorMsg: action.payload.error
            }
        default:
            return state;
    }
}

export default renewNumberReducer